const initialState = {
  authToken: "",
  selectedData: [],
  orderCounts: {},
  customerList: [],
};

module.exports = initialState;
